import API from './base';
import { ReviewerType } from '../enums';

export type ReviewPayload = {
  school_id: string,
  stars: number,
  comment: string,
  firstname: string,
  lastname: string,
  email: string,
  reception?: number,
  information?: number,
  teaching?: number,
  availability?: number,
  quality?: number,
  conditions_accepted: string,
  license_type?: string,
  nb_of_theory_exam?: number,
  nb_of_driving_exam?: number,
  full_cost?: number,
  nb_of_driving_lesson?: number,
  practical_exam_date?: string,
  allow_maif_proposal?: boolean,
  offer?: number,
  estimate?: number,
  documents?: number,
  indulgence?: number,
  billing?: number,
  reviewer_type?: ReviewerType,
  review_request_id?: string,
};

export type RefReviewPayload = {
  partner_review_payload_id: string,
  stars: number,
  comment: string,
  reception?: number,
  information?: number,
  teaching?: number,
  availability?: number,
  quality?: number,
  conditions_accepted: string,
  practical_exam_date?: string,
  allow_maif_proposal?: boolean,
  offer?: number,
  estimate?: number,
  documents?: number,
  indulgence?: number,
  billing?: number,
  reviewer_type?: ReviewerType,
};

class SchoolReviewAPI extends API {
  create(payload: ReviewPayload) {
    return this.post('/api/web/v1/reviews', payload);
  }

  createReferral(payload: RefReviewPayload) {
    return this.post('/api/web/v1/reviews/create_referral', { review: payload });
  }
}

export default new SchoolReviewAPI();
